import React from 'react'
import Icons from '../UI/Icons'
import './style.scss'
import Button from '../UI/Button'
import AiLoadingIcon from '../LoadingIcons/aiLoadingIcon'
import axios from '~/data/http/axios'
import ChipUpsell from '../UI/Chips/Upsell'
import i18n from '~/i18n'

const AiSubjectLineSuggestor = ({ onSuggestionSelected, templateId }) => {
    const [isLoading, setIsLoading] = React.useState(true)
    const [suggestions, setSuggestions] = React.useState([])
    const [noResults, setNoResults] = React.useState(false)
    const [error, setError] = React.useState(null)

    const fetchSuggestions = async () => {
        setIsLoading(true)
        setError(null)
        try {
            axios.post('/campaign/ai-subject-suggestions', { templateId, suggestions }).then((response) => {
                console.log(response.data)
                if (response.data.suggestions[0] === 'false') {
                    setNoResults(true)
                    setIsLoading(false)
                    return
                }
                setSuggestions(response.data.suggestions)
                setNoResults(false)
                setIsLoading(false)
            })
        } catch (err) {
            setError(i18n.t('campaigns:add.aiSubjectLineSuggestor.error'))
            setIsLoading(false)
        }
    }

    const handleRegenerate = () => {
        fetchSuggestions()
    }

    React.useEffect(() => {
        if (templateId && suggestions.length === 0) {
            fetchSuggestions()
        }
    }, [templateId])

    return (
        <div className='ai-subject-suggestor'>
            <div className='ai-subject-suggestor__header'>
                <div className='ai-subject-suggestor__header-title'>
                    <Icons icon='sparkleGradient' style={{ height: '20px', width: '20px' }} />
                    {i18n.t('campaigns:add.aiSubjectLineSuggestor.title')}
                    <ChipUpsell hideIcon={true}>{i18n.t('campaigns:add.aiSubjectLineSuggestor.beta')}</ChipUpsell>
                </div>
                <div className='ai-subject-suggestor__header-actions'>
                    {!isLoading && (
                        <Button
                            variant='secondary'
                            size='s'
                            onClick={handleRegenerate}
                            disabled={isLoading}
                            data-ph='ai-subject-suggestor-regenerate'
                        >
                            {i18n.t('campaigns:add.aiSubjectLineSuggestor.regenerate')}
                        </Button>
                    )}
                </div>
            </div>
            <div className='ai-subject-suggestor__body'>
                {isLoading && (
                    <div className='ai-subject-suggestor__loading'>
                        <AiLoadingIcon />
                        <p>{i18n.t('campaigns:add.aiSubjectLineSuggestor.fetching')}</p>
                    </div>
                )}
                {error && !noResults && <div className='ai-subject-suggestor__error'>{error}</div>}
                {noResults && (
                    <div className='ai-subject-suggestor__no-results'>
                        {i18n.t('campaigns:add.aiSubjectLineSuggestor.noSuggestions')}
                    </div>
                )}
                {!isLoading && !error && !noResults && (
                    <>
                        <p>{i18n.t('campaigns:add.aiSubjectLineSuggestor.suggestions')}</p>
                        <ul className='ai-subject-suggestor__suggestions'>
                            {suggestions.map((suggestion, index) => (
                                <li
                                    key={index}
                                    className='ai-subject-suggestor__suggestion'
                                    data-ph='ai-subject-suggestor-suggestion'
                                    onClick={() => onSuggestionSelected(suggestion)}
                                >
                                    {suggestion}
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
        </div>
    )
}

export default AiSubjectLineSuggestor
